'use strict'

const search = {

    init: function () {
        this.handleOpenSearch()
    },

    handleOpenSearch: function () {
        const searchs = document.querySelectorAll('.headerNav__search');
        const close = document.querySelector('.searchPopUp__close');
        const form = document.querySelector('.formSearch__barSearch');
        searchs.forEach(item => {
            item.addEventListener('click', () => {
                document.querySelector('.searchPopUp').classList.add('active');
                document.querySelector('body').classList.add('push');
                form.focus();
            })
        })

        close.addEventListener('click', () => {
            document.querySelector('.searchPopUp').classList.remove('active');
            document.querySelector('body').classList.remove('push');
            document.querySelector('.headerNav__search').focus();
        })

        close.addEventListener("focusout", () => {
            document.querySelector('.searchPopUp').classList.remove('active');
            document.querySelector('body').classList.remove('push');
            document.querySelector('.headerNav__search').focus();
        })
    }

}

export default search;